import React from 'react';
import { Switch, Row, Col } from 'antd';
import './setting.less'
import { AUTO_APPROVAL_ACTION_MAPPING } from "./constants";

function ApprovalSettingView({
    lenderPreferences, 
    handlePreferenceChange,
    translate  }) {

    return (
        <div className='approval-setting-container'>
            <h1 className='approval-setting-title'>{translate('autoApproval.lender_admin_heading_auto_approval')}</h1>
            <p className='approval-setting-description'>{translate('autoApproval.lender_admin_body_auto_approval')}</p>
            <div>
                {
                    lenderPreferences.map(preference => {
                        return (
                            <Row className='approval-setting-switch-row'>
                            <Col span={6}className='approval-setting-switch-name'>{preference.product_name}</Col>
                            <Col span={6}><Switch style={{opacity: !preference.auto_approval_editable ? '0.2' : ''}}  size='default' checked={preference.auto_approval_enabled} onChange={(checked, event) => handlePreferenceChange(AUTO_APPROVAL_ACTION_MAPPING.saveNewPreference, preference.product_code, checked, preference.auto_approval_editable)}/></Col>
                            </Row>
                        )
                    })
                }
            </div>
        </div>
    )
} 

export default ApprovalSettingView;